import { CustomAttributeFieldType } from '@risksmart-app/form-configuration/src/field-types/types';

import { attachFile } from './attachfile';
import { date } from './date';
import { departmentMultiselect } from './departmentMultiselect';
import { link } from './link';
import { multiselect } from './multiselect';
import { number } from './number';
import { select } from './select';
import { tags } from './tags';
import { text } from './text';
import { textArea } from './textarea';
import type { FieldTypeConfig } from './types';
import { userMultiselect } from './userMultiselect';

export type FieldTypesConfig = {
  [key in CustomAttributeFieldType]: FieldTypeConfig;
};

// Iteration order drives the field-type picker order (both the V3
// form-editor-dialog and the legacy edit-field-modal map over this in insertion
// order). Attach file sits last so it appears at the bottom of the list.
export const fieldTypesConfig: FieldTypesConfig = {
  [CustomAttributeFieldType.Text]: text,
  [CustomAttributeFieldType.Date]: date,
  [CustomAttributeFieldType.Textarea]: textArea,
  [CustomAttributeFieldType.Select]: select,
  [CustomAttributeFieldType.MultiSelect]: multiselect,
  [CustomAttributeFieldType.Number]: number,
  [CustomAttributeFieldType.Link]: link,
  [CustomAttributeFieldType.DepartmentMultiSelect]: departmentMultiselect,
  [CustomAttributeFieldType.UserMultiSelect]: userMultiselect,
  [CustomAttributeFieldType.Tags]: tags,
  [CustomAttributeFieldType.AttachFile]: attachFile,
};
